import React from 'react';
import { BulkActionModal } from '~/components/bulk-action';
import { useApi, useWorkspace } from '~/contexts';

function MemberInvitationDetails({ member }) {
  return [member.name, member.email].filter(Boolean).join(' - ');
}

export default function BulkSendInvitation({ ids, onClose, onComplete }) {
  const api = useApi();
  const { workspace } = useWorkspace();

  return (
    <BulkActionModal
      title="Send Invitation"
      confirmText="Send"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .members()
          .bulkSendInvitation(ids)
          .then((response) => response.data)
      }
      renderRow={MemberInvitationDetails}>
      <BulkActionModal.Body>
        <p>
          Invitation emails will be sent to each of the selected members. Any members that cannot be invited because
          they are set to inactive, are not allowed to login, or already accepted an invite will be skipped
          automatically.
        </p>
      </BulkActionModal.Body>
    </BulkActionModal>
  );
}
